// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
//import registerServiceWorker from './registerServiceWorker';
//ReactDOM.render(<App />, document.getElementById('root'));

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import store from './store'
import App from './App'

import './css/index.css'

const target = document.querySelector('#root')

// reload production on errors
try {
  render(
    <Provider store={store}>
        <div>
          <App />
        </div>
    </Provider>,
    target
  )

  if (module.hot) {
    module.hot.accept('./App', () => {
      const NextApp = require('./App').default;
      render(
  	  <Provider store={store}>
  	      <div>
  	        <NextApp />
  	      </div>
  	  </Provider>,
  	  target
      );
    });
  }
} catch(e) {
  // if there's an uncaught error in production, reset everything
  if (process.env.NODE_ENV === 'production') {
    window.location.reload();
  } else {
    throw(e);
  }
}


setInterval(() => {
  // for now just reload every few hours, but we'll make this smarter
  window.location.reload(true);
}, 1000*60*60*1)
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js